export enum UserSourceEnum {
  INVITATION_APP_IOS = "INVITATION_APP_IOS",
  INVITATION_APP_ANDROID = "INVITATION_APP_ANDROID",
  EVENTO_APP_IOS = "EVENTO_APP_IOS",
  EVENTO_APP_ANDROID = "EVENTO_APP_ANDROID",
  BUSINESS_APP_IOS = "BUSINESS_APP_IOS",
  BUSINESS_APP_ANDROID = "BUSINESS_APP_ANDROID",
  EVENTO = "EVENTO",
  BUSINESS_DASHBOARD = "BUSINESS_DASHBOARD",
  FDL = "FDL",
  THE_STAGE = "THE_STAGE",
  CHAMPION_WEBSITE = "CHAMPION_WEBSITE",
  TEAM_WEBSITE = "TEAM_WEBSITE",
}
